import { formatAriaKeyshortcutsMany } from '@/lib/keyboard/keyboard-shortcuts'
import type { ZoomMenuOption } from '../types/zoom-menu-option'

/** Preset zoom levels (percent), excluding fit — order matches typical editor menus. */
const ZOOM_PRESET_PERCENTS = [25, 50, 75, 100, 125, 150, 200, 400, 800] as const

export function buildMenuOptions(onZoomToSelection: (() => void) | undefined): ZoomMenuOption[] {
  const opts: ZoomMenuOption[] = [{ kind: 'actualSize' }, { kind: 'fit' }]

  if (onZoomToSelection) {
    opts.push({ kind: 'zoomSelection' })
  }

  for (const p of ZOOM_PRESET_PERCENTS) {
    opts.push({ kind: 'preset', percent: p })
  }

  return opts
}

export function zoomOptionKey(opt: ZoomMenuOption): string {
  return `${opt.kind}-${opt.kind === 'preset' ? opt.percent : opt.kind}`
}

/** `aria-keyshortcuts` for the zoom combobox: the menu's command rows that have shortcuts. */
export function formatZoomMenuAriaKeyshortcuts(hasZoomToSelection: boolean): string {
  return formatAriaKeyshortcutsMany(
    hasZoomToSelection
      ? (['actualSize', 'fitToSpread', 'zoomToSelection'] as const)
      : (['actualSize', 'fitToSpread'] as const)
  )
}

/** Disabled rows (Fit to spread, Zoom to Selection) are skipped by keyboard highlight. */
export function isSkippedZoomOption(
  opt: ZoomMenuOption | undefined,
  {
    zoomSelectionRowDisabled,
    fitToSpreadDisabled,
  }: {
    zoomSelectionRowDisabled: boolean
    fitToSpreadDisabled: boolean
  }
): boolean {
  if (opt?.kind === 'zoomSelection' && zoomSelectionRowDisabled) return true
  if (opt?.kind === 'fit' && fitToSpreadDisabled) return true

  return false
}
